module.exports = __webpack_public_path__ + "static/img/ptld_9.6946cbb9.png";